import { Button } from '@mantine/core';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useHostContext } from '@/context/HostContext.tsx';

type CreatorChatFlowNextStepsProps = {
	agentName: string;
	agentPhone: string;
	customerName: string;
	ownerCallDatetime: string;
};

const CreatorChatFlowNextSteps: FC<CreatorChatFlowNextStepsProps> = ({
	agentName,
	agentPhone,
	customerName,
	ownerCallDatetime
}) => {
	const { localization } = useHostContext();
	const formattedWhen = ownerCallDatetime
		? dayjs(ownerCallDatetime).format('MMMM D, YYYY [at] h:mm A')
		: localization.translate('creator', 'chatFlow.nextSteps.fallbackWhen');

	return (
		<div
			className="flex h-[min(41vh,520px)] w-[min(43vw,620px)] min-w-[520px] flex-col rounded-[28px] border border-[#E8E8E8] bg-[rgba(244,247,250,0.62)] px-8 py-8 backdrop-blur-[22px]"
			data-testid="creator-chat-flow-next-steps"
		>
			<div className="text-[34px] font-semibold leading-[1.02] text-primary-900/90 [font-family:var(--font-headlines)]">
				{localization.translate('creator', 'chatFlow.nextSteps.title')}
			</div>

			<div className="mt-6">
				<Button
					color="gray"
					fullWidth
					radius={18}
					size="lg"
					styles={{
						label: {
							fontSize: '22px',
							fontWeight: 500
						},
						root: {
							background: 'rgba(255, 255, 255, 0.85)',
							border: '1px solid #E8E8E8',
							color: 'rgba(15, 23, 42, 0.82)',
							height: '62px'
						}
					}}
					variant="default"
				>
					{agentPhone}
				</Button>
			</div>

			<div className="mt-6 rounded-[24px] border border-[#E8E8E8] bg-white/65 px-6 py-6 text-primary-900/88">
				<div className="text-[19px] leading-[1.5] text-primary-900/72">
					{localization
						.translate('creator', 'chatFlow.nextSteps.description')
						.replace('{agentName}', agentName)}
				</div>

				<div className="mt-6 text-[18px] leading-[1.5]">
					<span className="font-semibold text-primary-900/82">
						{localization.translate('creator', 'chatFlow.nextSteps.whenLabel')}
					</span>{' '}
					<span>{formattedWhen}</span>
				</div>

				<div className="mt-4 text-[18px] leading-[1.5]">
					<span className="font-semibold text-primary-900/82">
						{localization.translate(
							'creator',
							'chatFlow.nextSteps.attendersLabel'
						)}
					</span>{' '}
					<span>
						{customerName}, {agentName}
					</span>
				</div>
			</div>
		</div>
	);
};

export default CreatorChatFlowNextSteps;
